import './RoundShape.less';
/**
 * @component RoundShape.tsx
 * @description Round Shape to pick Up the color.
 * @return { component }
 */
interface RoundShapeProps {
  color: string;
  width: string;
  height: string;
  colorOnClick: (show: string) => void;
  isEdit: boolean
}
function RoundShape(props: RoundShapeProps) {
  const colorOnClick = () => {
    props.colorOnClick(props.color);
  };
  return (
    <div
      className="at-round-shape"
      style={{
        background: props.color,
        width: props.width,
        height: props.height,
        border: '2px solid #DCDCDC'
      }}
      onClick={colorOnClick}
    />
  );
}

export default RoundShape;
